/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import UpgradePricing from 'app/components/Subscription/UpgradePricing.jsx';
import LegacyPricing from 'app/components/Subscription/LegacyPricing.jsx';
import PricingMatrix from 'app/components/Subscription/PricingMatrix.jsx';
import DowngradeModal from 'app/components/Subscription/DowngradeModal.jsx';
import ConfirmationModal from 'app/components/Subscription/ConfirmationModal.jsx';
import CancellationModal from 'app/components/Subscription/Cancellation/CancellationModal.jsx';
import Loading from 'app/components/common/Loading.jsx';
import AnalyticsMixin from 'app/mixins/AnalyticsMixin.js';
import PricingModule from 'app/mixins/PricingModule.jsx';
import * as _ from 'underscore';
import { Link } from 'react-router-dom';
import { FormattedNumber } from 'react-intl';
import CreditCardModal from 'app/components/Subscription/CreditCardModal.jsx';
import EmptyState from 'app/components/common/EmptyState.jsx';
import PlanDetailBlock from 'app/components/Subscription/PlanDetailBlock.jsx';
import TDSChallengeModal from 'app/components/Subscription/TDSChallengeModal.jsx';
import { compose } from 'redux';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import UserMessages from 'app/modules/UserMessageModule.js';
import { setLauncherVisible } from 'app/utility/Intercom.js';
import SubscriptionPage from '@/shadcn/components/account/SubscriptionPage/SubscriptionPage.tsx';

import makeToast from 'app/modules/makeToast.js';

class Subscription extends React.Component {
	constructor(props) {
		super(props);

		let requestedPlan = 0;

		if (requestedPlan === 0 && this.props.user.detail.pubLevel) {
			requestedPlan = this.props.user.detail.pubLevel;
		}

		let term = 1,
			addOns = 0;

		this.state = {
			subscription: {
				level: requestedPlan,
				addOns,
				addOnPosts: 0,
				term
			},
			errors: null,
			trackingAction: '',
			callUpdatePlan: false,
			challengeModal: false,
			requestData: null,
			requestMethod: null
		};

		this.planChange = React.createRef();

		this.checkForRedirect = this.checkForRedirect.bind(this);
		this.updateSubscriptionAddOns = this.updateSubscriptionAddOns.bind(this);
		this.changePlan = this.changePlan.bind(this);
		this.updatePlan = this.updatePlan.bind(this);
		this.createSubscription = this.createSubscription.bind(this);
		this.setPlan = this.setPlan.bind(this);
		this.setTerm = this.setTerm.bind(this);
		this.planUpgrade = this.planUpgrade.bind(this);
		this.restartPlan = this.restartPlan.bind(this);
		this.showCreditCardModal = this.showCreditCardModal.bind(this);
		this.cancelPlan = this.cancelPlan.bind(this);
		this.setRequestParams = this.setRequestParams.bind(this);
		this.promoClick = this.promoClick.bind(this);
		this.confirmationCancel = this.confirmationCancel.bind(this);

	}

	componentDidMount() {

		setLauncherVisible(false);

		if ((this.props.recordEvent) && this.props.router.location.pathname.match(/\/account\/subscription\??/)) {

			if (this.props.recordEvent) {
				this.props.recordEvent({
					pub_id: this.props.user.detail.id,
					event_name: 'Subscription Page Loaded',
					event_data: {

					}
				});
			}
		}

		this.props.getSubscription();
		this.props.getPlanDetail(this.props.user.detail.pubLevel);
		this.props.getPlans();

	}

	componentDidUpdate(prevProps, prevState) {

		this.checkForRedirect(this.props);

		let subscription = this.state.subscription,
			nextModal = null,
			variant = '',
			addOnPrice = null,
			products = [],
			trackingAction = this.state.trackingAction,
			errors = [],
			constants = this.props.app.config.constants,
			requestData = this.state.reqeustData,
			requestMethod = this.state.requestMethod,
			challengeModal = this.state.challengeModal;

		if (this.state.selectedPlan === 0 && this.props.user.detail.pubLevel) {
			subscription.level = this.props.user.detail.pubLevel;
			this.setState({
				subscription
			});
		}

		if (this.props.user.detail.isAgent) {
			return;
		}

		if (prevProps.app.loading.SUB_FETCH === true && this.props.app.loading.SUB_FETCH === false) {
			subscription.addOns = (this.props.plans.current.addOns && this.props.plans.current.addOns !== undefined && this.props.plans.current.addOns.add_on_social !== undefined) ? this.props.plans.current.addOns.add_on_social.qty : 0;
			subscription.addOnPosts = (this.props.plans.current.addOns && this.props.plans.current.addOns !== undefined && this.props.plans.current.addOns.add_on_posts_1 !== undefined) ? this.props.plans.current.addOns.add_on_posts_1.qty : 0;
			subscription.term = parseInt(this.props.plans.current.planTerm);

			// let passed in values override the current values... useful for when someone makes
			// adjustments on the matrix page during a plan change and comes back here
			if (window.location.search !== '') {
				let matches = window.location.search.match(/plan=([\d]+)/);
				if (matches !== null && matches[1] !== undefined) {
					subscription.level = parseInt(matches[1]);
				}

				let termMatches = window.location.search.match(/term=([\d]+)/);
				if (termMatches !== null && termMatches[1] !== undefined) {
					subscription.term = parseInt(termMatches[1]);
				}

				let addOnMatches = window.location.search.match(/addons=([\d]+)/);
				if (addOnMatches !== null && addOnMatches[1] !== undefined) {
					subscription.addOns = parseInt(addOnMatches[1]);
				}
			}
		}

		let subUpdateSettled = prevProps.app.loading.SUB_UPDATE === true && this.props.app.loading.SUB_UPDATE === false,
			subCreateSettled = prevProps.app.loading.SUB_CREATE === true && this.props.app.loading.SUB_CREATE === false,
			subAddOnSettled  = prevProps.app.loading.SUB_ADDON_UPDATE === true && this.props.app.loading.SUB_ADDON_UPDATE === false;

		// Only read errors for a request that just settled — an unconditional read picks up stale
		// errors left in redux by other views (SubscriptionNew) and toasts them here.
		// SUB_ADD_ON_UPDATE errors are also surfaced in the confirmation modal.
		if (subUpdateSettled || subCreateSettled || subAddOnSettled) {
			errors = this.props.getApiErrors(['SUB_UPDATE', 'SUB_ADDON_UPDATE', 'SUB_CREATE']);
		}

		if (errors.length) {
			let nextError = errors[0];

			if (this.props.recordEvent) {
				this.props.recordEvent({
					pub_id: this.props.user.detail.id,
					event_name: 'Subscription Update Error',
					event_data: {
						error: JSON.stringify(errors[0].errors)
					}
				});
			}

			if (nextError?.errors?.subscription?.TDSChallenge !== undefined && nextError?.errors?.subscription?.TDSChallenge !== null &&
				!this.state.challengeModal) {
				this.setState({
					challengeModal: true
				});
				this.props.closeOtherModals(
					<TDSChallengeModal
						{...this.props}
						TDSChallenge={errors[0]?.errors?.subscription?.TDSChallenge}
						requestData={this.state.requestData}
						requestMethod={this.state.requestMethod}/>
				);
			} else if (nextError?.errors?.subscription?.message?.match(/past due|expired|insufficient|transaction|decline/i)) {
				this.props.closeAllModals();
				makeToast("", "error", {
					title: "Payment failed",
					description: "Update billing details",
					action: {
						label: 'Update',
						onClick: () => {
							this.props.router.navigate("/account/billing?update=true");
							this.props.closeAllModals();
						}
					}
				});
			} else if (nextError?.errors?.subscription?.message?.match(/The submitted values match the current subscriptions values/)) {
				// this is a spurious error thrown by updateSubscriptionAddOns when updating a subscription
				nextError = null;
				this.props.getUser();
				this.props.getUserPerms();
				this.props.closeAllModals();
			}

			if (nextError?.errors?.subscription?.TDSChallenge === undefined || errors[0]?.errors?.subscription?.TDSChallenge === null) {
				this.props.closeAllModals();
			}

			this.setState({
				errors: nextError
			});

			this.props.deleteApiError(['SUB_UPDATE', 'SUB_ADDON_UPDATE', 'SUB_CREATE']);
		} else if (subUpdateSettled || subCreateSettled) {
			// refresh the user and perms
			this.props.getUser();
			this.props.getUserPerms();
			this.props.closeAllModals();

			if (subUpdateSettled) {
				// reroute from plan display to sub display
				this.props.router.navigate("/account/subscription");
			}
		}

		if (prevProps.app.loading.SUB_APPLY_COUPON === true && this.props.app.loading.SUB_APPLY_COUPON === false) {
			let couponErrors = this.props.getApiErrors(['SUB_APPLY_COUPON']);
			// a failed redemption is reported inline by the cancellation flow instead
			if (!couponErrors.length) {
				makeToast("Discount applied", "success");
				this.props.closeAllModals();
			}
		}

		if (prevProps.app.loading.SUB_PAUSE_SUBSCRIPTION === true && this.props.app.loading.SUB_PAUSE_SUBSCRIPTION === false) {
			let pauseErrors = this.props.getApiErrors(['SUB_PAUSE_SUBSCRIPTION']);
			// a failed pause is reported inline by the cancellation flow instead
			if (!pauseErrors.length) {
				this.props.closeAllModals();
				this.props.getUser();
				this.props.getUserPerms();
			} else {
				let errorMessage = pauseErrors[0]?.errors?.recurly?.error;
				if (errorMessage) {
					makeToast(errorMessage, "error");
				}
				this.props.deleteApiError(['SUB_PAUSE_SUBSCRIPTION']);
			}
		}

		if (prevState.callUpdatePlan === false && this.state.callUpdatePlan === true) {
			this.updatePlan();
			this.setState({
				callUpdatePlan: false
			});
		}

		// new sub else updated sub
		if (this.props.isFreeOrTrialUser(prevProps.user.detail.pubLevel) && !this.props.isFreeOrTrialUser()) {
			this.props.getUser();
			this.props.getUserPerms();

			this.props.closeAllModals();

			// if (dataLayer) {
            //     products.push({
            //         'name': this.props.plans.current.planName,     // Name or ID is required.
            //         'price': this.props.plans.current.price,
            //         'quantity': 1,
            //         'variant': 'new'
            //     });
			//
            //     dataLayer.push({
            //         'event': 'purchase',
            //         'ecommerce': {
            //             'purchase': {
            //                 'actionField': {
            //                     'id': this.props.plans.current.uuid, // Transaction ID. Required for purchases and refunds.
            //                     'revenue': this.props.plans.current.price
            //                 },
            //                 'products': products
            //             }
            //         },
			// 		// GA4 params
			// 		'transaction_id': this.props.plans.current.uuid,
			// 		'value': 1.00,
			// 		items: [
			// 			{
			// 				item_id: 'dlvrit_1',
			// 				item_name: 'dlvr.it premium plan',
			// 				price: 1.00,
			// 				quantity: 1
			// 			}
			// 		]
            //     });
            // }

			if (gtag) {
				let promoData = this.props.getPersistedData('gaPromo');

				gtag('event', 'purchase', {
					transaction_id: this.props.plans.current.uuid,
					value: 1.00,
					currency: 'USD',
					items: [
						{
							item_id: 'dlvrit_1',
							item_name: 'dlvr.it premium plan',
							item_variant: 'New Plan',
							price: 1.00,
							quantity: 1,
							promotion_id: (promoData !== undefined && promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
			                promotion_name: (promoData !== undefined && promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
						}
					],
				});

				if (this.props.recordEvent) {
					this.props.recordEvent({
						pub_id: this.props.user.detail.id,
						event_name: 'New Plan Purchase',
						event_data: {
							promotion_id: (promoData !== undefined && promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
			                promotion_name: (promoData !== undefined && promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
						}
					})
				}

				this.props.clearPersistedData('gaPromo');
			}

			nextModal = (
                <ConfirmationModal
					{...this.props}
                    confirmationType="newpaidsubscription"
                    confirmationAction={this.props.closeAllModals}
                    planLevel={this.props.plans.current.planLevel}
                    planTerm={this.props.plans.current.planTerm} />
			);

			this.props.addModal(nextModal);

		} else if ((!_.isEmpty(prevProps.plans.current) && !_.isEqual(prevProps.plans.current, this.props.plans.current)) ||
					(!prevProps.user.detail.subscriptionState === constants.SUBSCRIPTION_ACTIVE && this.props.user.detail.subscriptionState === constants.SUBSCRIPTION_CANCELLED)) {
			this.props.getUser();
			this.props.getUserPerms();
			this.props.closeAllModals();

			// reset any 3DS challenge related variables
			requestData = null;
			requestMethod = null;

			if (challengeModal) {
				challengeModal = false;
				this.props.closeAllModals();
				this.setState({
					errors: null
				});
			}

			if (dataLayer !== undefined || gtag !== undefined) {
				switch (this.state.trackingAction) {
					case 'planupgrade':
					case 'downgrade':
					case 'termchange':
						dataLayer.push({
							'event': 'plan-change',
							'old-plan-name': AnalyticsMixin.getPlanLabel(prevProps.user.detail.pubLevel, prevProps.plans.current.planTerm),
							'new-plan-name': AnalyticsMixin.getPlanLabel(this.props.plans.current.planLevel, this.props.plans.current.planTerm)
						});
						if (this.state.trackingAction === 'planupgrade' || this.state.trackingAction === 'termchange') {
							if (this.state.trackingAction === 'planupgrade') {
								products.push({
									'name': AnalyticsMixin.getPlanLabel(this.props.plans.current.planLevel, this.props.plans.current.planTerm),
									'price': this.props.plans.details[this.props.plans.current.planLevel].price[this.props.plans.current.planTerm],
									'quantity': 1,
									'variant': 'upgrade plan'
								});
							} else {
								variant = 'term change';
								products.push({
									'name': AnalyticsMixin.getPlanLabel(this.props.plans.current.planLevel, this.props.plans.current.planTerm),
									'price': this.props.plans.details[this.props.plans.current.planLevel].price[this.props.plans.current.planTerm],
									'quantity': 1,
									'variant': 'term change'
								});
							}

							// dataLayer.push({
					        //     'event': 'purchase',
					        //     'ecommerce': {
							// 		'purchase': {
							// 			'actionField': {
							// 				'id': this.props.plans.current.uuid,   // Transaction ID. Required for purchases and refunds.
							// 				'revenue': products[0].price                 // Total transaction value (incl. tax and shipping)
							// 			},
							// 			'products': products
							// 		}
					        //     }
					        // });

							if (gtag) {
								let txID = '',
									promoData = this.props.getPersistedData('gaPromo');

								if (this.state.trackingAction === 'planupgrade') {
									txID = this.props.plans.current.uuid + "_planupgrade_" + new Date().getTime();
									gtag('event', 'purchase', {
										transaction_id: txID,
				                        value: 1.00,
				                        currency: 'USD',
				                        items: [
				                            {
				                                item_id: 'dlvrit_1',
				    	                        item_name: 'dlvr.it premium plan',
				                                item_variant: 'Plan Upgrade',
				    	                        price: 1.00,
				    	                        quantity: 1,
												promotion_id: (promoData !== undefined && promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
								                promotion_name: (promoData !== undefined && promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
				                            }
				                        ],

									});
								} else {
									txID = this.props.plans.current.uuid + "_termchange_" + new Date().getTime();
									gtag('event', 'purchase', {
										transaction_id: txID,
				                        value: 1.00,
				                        currency: 'USD',
				                        items: [
				                            {
				                                item_id: 'dlvrit_1',
				    	                        item_name: 'dlvr.it premium plan',
				                                item_variant: 'Term Change',
				    	                        price: 1.00,
				    	                        quantity: 1,
												promotion_id: (promoData !== undefined && promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
								                promotion_name: (promoData !== undefined && promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
				                            }
				                        ],

									});
								}
							}
						}


						break;

					case 'addons':
						let sign = "+";

						variant = 'addon upgrade';
						addOnPrice = this.props.plans.details[this.props.plans.current.planLevel].addOnPrices[this.props.plans.current.planTerm];

						if (this.props.plans.current.addOns) {
							if (_.isObject(this.props.plans.current.addOns.add_on_social) &&
									(prevProps.plans.current.addOns && _.isObject(prevProps.plans.current.addOns.add_on_social))) {
								if (prevProps.plans.current.addOns.add_on_social.qty < this.props.plans.current.addOns.add_on_social.qty) {
									sign = "-";
									variant = 'addon downgrade';
								}
							}
						}

						dataLayer.push({
							'event': 'plan-addon-change',
							'plan-name': AnalyticsMixin.getPlanLabel(this.props.plans.current.planCode, this.props.plans.current.planTerm),
							'add-on-change': [sign, this.props.plans.current.addOns].join("")
						});

						if (sign === "+") {
							products.push({
								'name': 'Add On',
								'price': addOnPrice,
								'quantity': this.props.plans.current.addOns,
								'variant': variant
							});

							// dataLayer.push({
					        //     'event': 'purchase',
					        //     'ecommerce': {
							// 		'purchase': {
							// 			'actionField': {
							// 				'id': this.props.plans.current.uuid,  // Transaction ID. Required for purchases and refunds.
							// 				'revenue': addOnPrice * this.state.subscription.addOns  // Total transaction value (incl. tax and shipping)
							// 			},
							// 			'products': products
							// 		}
					        //     }
					        // });

							if (gtag) {
								let promoData = this.props.getPersistedData('gaPromo');

								gtag('event', 'purchase', {
									transaction_id: this.props.plans.current.uuid + '_addonpurchase_' + new Date().getTime(),
									value: 1.00,
									currency: 'USD',
									items: [
										{
											item_id: 'dlvrit_1',
											item_name: 'dlvr.it premium plan',
											item_variant: 'Add-On Purchase',
											price: 1.00,
											quantity: 1,
											promotion_id: (promoData !== undefined && promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
							                promotion_name: (promoData !== undefined && promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
										}
									],

								});

								if (this.props.recordEvent) {
									this.props.recordEvent({
										pub_id: this.props.user.detail.id,
										event_name: 'Add-On Purchase',
										event_data: {
											'plan-name': AnalyticsMixin.getPlanLabel(this.props.plans.current.planCode, this.props.plans.current.planTerm),
											'add-on-change': [sign, this.props.plans.current.addOns].join(""),
											promotion_id: (promoData !== undefined && promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
							                promotion_name: (promoData !== undefined && promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
										}
									});
								}

								this.props.clearPersistedData('gaPromo');
							}
						}
						break;

					case 'addonposts':
						let action = "Increase";
						if (_.isObject(prevProps.plans.current.addOns.add_on_posts_1) &&
							(!_.isObject(this.props.plans.current.addOns.add_on_posts_1) ||
							prevProps.plans.current.addOns.add_on_posts_1.qty > this.props.plans.current.addOns.add_on_posts_1.qty)) {
							action = "Decrease";
						}
						let quantity = 0;
						if (_.isObject(this.props.plans.current.addOns.add_on_posts_1)) {
							quantity = this.props.plans.current.addOns.add_on_posts_1.qty;
						}
						if (this.props.recordEvent) {
							this.props.recordEvent({
								pub_id: this.props.user.detail.id,
								event_name: `Add On Posts ${action}`,
								event_data: {
									quantity
								}
							});
						}
						break;

					default:
						break;
				}

			}

			this.setState({
				trackingAction: '',
				requestData,
				requestMethod,
				challengeModal
			});

		}

	}

	componentWillUnmount() {

		setLauncherVisible(true);

	}

	checkForRedirect(props) {

		let constants = this.props.app.config.constants;

		if (props.router.query && props.router.query.subscribe) {
			// can't directly set or clear the query string, but leave the code here
			// when it could in case i have a bug to fix
			//props.router.location.search = '';
			this.showCreditCardModal();
		}

		if (props.router.location.pathname.match("compare")) {
			return;
		}

		if (this.props.isFreeUser(props.user.detail.pubLevel) || this.props.isTrialUser(props.user.detail.pubLevel)) {
			if (props.router.location.pathname === "/account/subscription/change" && props.router.location.search === "?plan=9") {
				this.props.router.navigate('/account/subscription/new?plan=9');
			} else if (props.router.location.pathname.match("/account/subscription")) {
				this.props.router.navigate('/account/subscription/new');
			}
		} else {
			if (this.props.isPlusUser(props.user.detail.pubLevel) || this.props.isAgencyPlusUser(props.user.detail.pubLevel)) {
				if (props.router.location.pathname === "/account/subscription/change" && props.router.location.search === "?plan=9") {
					this.props.router.navigate('/account/subscription');
				}
			}
		}

	}

	updateSubscriptionAddOns(data) {
		let subscription = this.state.subscription,
			trackingAction = 'addons';

		this.props.updateAddOns(data);

		if (data.add_on_social !== undefined) {
			subscription.addOns = data.add_on_social;
		} else if (data.add_on_posts_1 !== undefined) {
			subscription.addOnPosts = data.add_on_posts_1;
			trackingAction = 'addonposts';
		}

		this.setState({
			trackingAction,
			subscription,
			errors: null,
			// store what we did in case we have to do it again after
			// a 3DS challenge
			requestData: data,
			requestMethod: this.props.updateAddOns
		});

	}

	changePlan(data) {

		let subscription = this.state.subscription;

		this.props.deleteApiError(['SUB_UPDATE', 'SUB_ADDON_UPDATE']);

		this.props.updateSubscription(data);

		// store what we did in case we have to do it again after
		// a 3DS challenge
		this.setState({
			errors: null,
			requestData: data,
			requestMethod: this.props.updateSubscription
		});

		if (data.trackingAction) {
			if (data.trackingAction !== "downgrade") {
				this.props.getPlanDetail(subscription.level);
			}
			if (data.add_on_social) {
				subscription.addOns = data.add_on_social;
			}
			if (data.level) {
				subscription.level = data.level;
			}
			if (data.term) {
				subscription.term = data.term;
			}
			this.setState({
				trackingAction: data.trackingAction,
				subscription
			});
		}

	}

	updatePlan(e) {

		let subscription = this.state.subscription,
			selectedPlan = this.state.subscription.level,
			nextModal = null,
			constants = this.props.app.config.constants,
			nextPlan = this.props.plans.details[this.state.subscription.level],
			nextTerm = this.state.subscription.term,
			adjustedAddOns = 0,
			newLimits = null,
			currentPlan = parseInt(this.props.plans.current.planLevel);

		this.props.deleteApiError(['SUB_UPDATE', 'SUB_ADDON_UPDATE']);

		if (e) {
			e.preventDefault();
		}

		let plansWithSocialAddOns = [
			constants.PUB_LEVEL_2,
			constants.PUB_LEVEL_6,
			constants.PUB_LEVEL_7,
			constants.PUB_LEVEL_8,
			constants.PUB_LEVEL_9,
			constants.PUB_LEVEL_10
		];

		newLimits = this.props.calculateAddOns([], nextPlan, nextTerm);

		if (plansWithSocialAddOns.indexOf(selectedPlan) !== -1) {
			if (this.props.plans.current.addOns && this.props.plans.current.addOns.add_on_social) {
				adjustedAddOns = this.props.getAdjustedAddOns(selectedPlan) + this.state.subscription.addOns;
				newLimits = this.props.calculateAddOns([{
					addOn: constants.SUBSCRIPTION_ADDON_SOCIALS,
					quantity: adjustedAddOns
				}], nextPlan);
				subscription.addOns = adjustedAddOns;
				this.setState({
					subscription
				});
			} else if (this.state.subscription.addOns > 0) {
				adjustedAddOns = this.state.subscription.addOns;
				newLimits = this.props.calculateAddOns([{
					addOn: constants.SUBSCRIPTION_ADDON_SOCIALS,
					quantity: this.state.subscription.addOns
				}], nextPlan);
			}
		} else if (plansWithSocialAddOns.indexOf(selectedPlan) === -1) {
			newLimits = this.props.calculateAddOns([{
				addOn: constants.SUBSCRIPTION_ADDON_SOCIALS,
				quantity: 0
			}], nextPlan);
			subscription.addOns = 0;
			this.setState({
				subscription
			});
		}

		// downgrade in process
		if (selectedPlan !== currentPlan && !this.props.isUpgrade(selectedPlan) || this.props.isFreeUser(selectedPlan)) {
			if (this.props.isFreeUser(selectedPlan)) {
				nextModal = (
					<CancellationModal
						{...this.props}
						newPlanLevel={selectedPlan}
						newPlanTerm={this.state.subscription.term}
						router={this.props.router}
						planChangeHandler={this.changePlan}
						adjustedAddOns={adjustedAddOns} />

				);
			} else {
				nextModal = (
					<DowngradeModal
						{...this.props}
						newPlanLevel={selectedPlan}
						newPlanTerm={this.state.subscription.term}
						router={this.props.router}
						planChangeHandler={this.changePlan}
						adjustedAddOns={adjustedAddOns} />

				);
			}
		} else {
			nextModal = (
				<ConfirmationModal
					{...this.props}
					confirmationType="planupgrade"
					subscription={this.props.plans.current}
					planLevel={selectedPlan}
					planTerm={this.state.subscription.term}
					confirmationAction={this.changePlan}
					adjustedAddOns={adjustedAddOns}
					newLimits={newLimits}
					onConfirmationCancel={this.confirmationCancel} />
			);
		}

		if (nextModal !== null) {
			this.props.addModal(nextModal);
			this.setState({
				errors: null
			});
		}

	}

	createSubscription(e) {
		e.preventDefault();

		this.showCreditCardModal();

	}

	setTerm(e) {
		let subscription = this.state.subscription;

		subscription.term = parseInt(e.currentTarget.dataset.term, 10);
		this.setState({
			subscription
		});

	}

	setPlan(e) {

		let nextPlan = parseInt(e.currentTarget.dataset.plan, 10),
			subscription = this.state.subscription,
			constants = this.props.app.config.constants,
			planError = this.state.planError,
			limits = null;

		subscription.level = nextPlan;

		// check that usage doesn't outstrip the plan unless the user is upgrading to plus
		// in which case we carry over the add-ons
		if (!this.props.isFreeUser(nextPlan) && (this.props.isPlusUser(nextPlan) || this.props.isAgencyPlusUser(nextPlan))) {
			limits = this.props.plans.details[nextPlan].limits;
			if (parseInt(limits.hardLimitInputs, 10) < (parseInt(this.props.user.perms.perms.hardLimitInputs, 10) - this.props.user.perms.resources.inputsAvailable) ||
				parseInt(limits.hardLimitOutputs, 10) < (parseInt(this.props.user.perms.perms.hardLimitOutputs, 10) - this.props.user.perms.resources.outputsAvailable)) {
				subscription.level = this.props.plans.current.planLevel;
				planError = "Changing your plan wouldn't support your current usage.";
			} else {
				planError = '';
			}
		} else {
			planError = '';
		}

		// GA4 commerce events
		// if (dataLayer) {
		// 	let planData = GetPlanData.lookupDetails(
		// 		subscription.level,
		// 		subscription.term
		// 	);
		// 	dataLayer.push({
		// 		'event': 'begin_checkout',
		// 		'currency': 'USD',
		// 		'value': planData.price,
		// 		'items': [{
		// 			item_id: planData.plan_id,
        //             item_name: planData.plan_name,
        //             price: planData.price,
        //             item_variant: 'plan_change',
        //             quantity: 1
		// 		}]
		// 	});
		// }

		if (gtag) {
			let promoData = this.props.getPersistedData('gaPromo');

			gtag('event', 'begin_checkout', {
				currency: 'USD',
				value: 1.0,
				items: [{
					item_id: 'dlvrit_1',
					item_name: 'dlvr.it premium plan',
					item_variant: 'Plan Change',
					price: 1.0,
					quantity: 1,
					promotion_id: (promoData !== undefined && promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
	                promotion_name: (promoData !== undefined && promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
				}],
			});
		}

		this.setState({
			subscription,
			planError
		});

	}

	planUpgrade(e, newLevel) {
		let subscription = this.state.subscription;
		subscription.level = newLevel;

		this.setState({
			subscription
		}, function() {
			this.updatePlan();
		});

	}

	cancelPlan(e) {

		let constants = this.props.app.config.constants,
			subscription = this.state.subscription;

		if (e) {
			e.preventDefault();
		}

		subscription.level = constants.PUB_LEVEL_1;
		subscription.term = constants.SUBSCRIPTION_TERM_MONTHLY;

		this.setState({
			subscription,
			callUpdatePlan: true
		});

	}

	restartPlan(e) {

		let constants = this.props.app.config.constants,
			subscription = this.state.subscription;

		if (e) {
			e.preventDefault();
		}

		subscription.level = this.props.user.detail.pubLevel;

		this.setState({
			subscription,
			callUpdatePlan: true
		});

	}

	showCreditCardModal(e) {
		let modalTerm = (this.state.subscription.term) ? this.state.subscription.term : constants.SUBSCRIPTION_TERM_ANNUAL,
			ccModal = null,
			addOns = {};

		if (this.props.plans.current.planLevel == this.state.subscription.level) {
			if (this.props.plans.current.addOns) {
				if (this.props.plans.current.addOns.add_on_social) {
					if (this.props.plans.current.addOns.add_on_social.qty) {
						addOns = {
							add_on_social: this.props.plans.current.addOns.add_on_social.qty
						};
					}
				}
			}
			if (_.isEmpty(addOns) && this.state.subscription.addOns) {
				addOns = {
					add_on_social: this.state.subscription.addOns
				};
			}
		}

		ccModal = (
			<CreditCardModal
				{...this.props}
				plan={this.state.subscription.level}
				planTerm={modalTerm}
				planPrice={0}
				username={this.props.user.detail.username}
				router={this.props.router}
				action={'subscribe'}
				errors={this.state.errors}
				changeTerm={this.setTerm}
				closeAction={this.props.closeAllModals}
				addOns={addOns} />
		);
	}

	setRequestParams(method, data) {
		this.setState({
			requestMethod: method,
			requestData: data
		});
	}

	promoClick(e) {
		e.preventDefault();

		let nextPlan = parseInt(e.currentTarget.dataset.plan);

		if (nextPlan) {
			// Shared by UpgradePricing and LegacyPricing, so this is the single choke
			// point for plan selection on /account/subscription. Same payload as
			// SubscriptionNew.startUpgrade; `source` distinguishes the surface.
			if (this.props.recordEvent) {
				let constants   = this.props.app.config.constants,
					term        = (parseInt(this.state.subscription.term, 10) === constants.SUBSCRIPTION_TERM_ANNUAL) ? ' Annual' : ' Monthly',
					planDetail  = this.props.plans.details ? this.props.plans.details[nextPlan] : null;

				this.props.recordEvent({
					pub_id: this.props.user.detail.id,
					event_name: 'Start Checkout',
					event_data: {
						plan: ((planDetail && planDetail.label) ? planDetail.label : nextPlan) + term,
						source: 'manage'
					}
				});
			}

			this.props.router.navigate(`/account/subscription/change?plan=${nextPlan}`);
		}

	}

	confirmationCancel() {
		let nextSubscription = Object.assign({}, this.state.subscription);

		nextSubscription.level = this.props.plans.current.planLevel;
		nextSubscription.term = this.props.plans.current.planTerm;

		if (this.props.plans.current.addOns && this.props.plans.current.addOns !== undefined) {
			if (this.props.plans.current.addOns.add_on_social !== undefined) {
				nextSubscription.addOns = this.props.plans.current.addOns.add_on_social.qty;
			}
			if (this.props.plans.current.addOns.add_on_posts_1 !== undefined) {
				nextSubscription.addOnPosts = this.props.plans.current.addOns.add_on_posts_1.qty;
			}
		}

		this.setState({
			subscription: nextSubscription
		})
	}

	render() {
		let constants = this.props.app.config.constants,
			content = null,
			legacyPlans = [
				constants.PUB_LEVEL_3,
				constants.PUB_LEVEL_4,
			];

		if (this.props.user.detail.isAgent) {
			return (
				<div className="app-column content main">
					<main className="content-container">
						<EmptyState
							message="Sorry, only the account owner can access this page."/>
					</main>
				</div>
			);
		}

		if (!_.isEmpty(this.props.plans.current) && (this.props.plans.current.status.canceled === false)) {
			// cancelBlock = (
			// 	<div className="cancel-plan-block">
			// 		<a href="#" onClick={this.cancelPlan}>Cancel your plan</a>
			// 	</div>
			// );
		} else if (!_.isEmpty(this.props.plans.current) && (this.props.plans.current.status.canceled === true)) {
			// if (!this.props.isFreeUser()) {
			// 	cancelBlock = (
			// 		<div className="cancel-plan-block">
			// 			<a href="#" onClick={this.restartPlan}>Restart your plan</a>
			// 		</div>
			// 	);
			// }
		}

		if (!_.isEmpty(this.props.plans.current) && this.props.plans.current.planTerm === constants.SUBSCRIPTION_TERM_ANNUAL) {
			// monthlyBlock = (
			// 	<div className="monthly-plan-block">
			// 		<a href="#" onClick={(e) => {
			// 			e.preventDefault();
			// 			e.stopPropagation();
			// 			this.props.changeTerm(e, this.props.setRequestParams)
			// 		}} data-term={this.props.app.config.constants.SUBSCRIPTION_TERM_MONTHLY}>Switch to monthly billing</a>
			// 	</div>
			// )
		}

		if (this.props.router.location.pathname.match(/compare/)) {
			content = (
				<PricingMatrix
					{...this.props}
					currentSubscription={this.state.subscription}
					plans={this.props.plans.details}
					planDetails={this.state.planDetails}
					onPlanUpdate={this.updatePlan}
					bannerVisible={this.props.bannerVisible}
					errors={this.state.errors} />
			);
		} else if (this.props.app.loading.SUB_FETCH_PLANS ||
				this.props.app.loading.SUB_FETCH_DETAIL ||
				this.props.app.loading.SUB_FETCH ||
				this.props.app.loading.SUB_UPDATE ||
				this.props.app.loading.SUB_ADDON_UPDATE ||
				 _.isEmpty(this.props.plans.details)) {
			content = <Loading />;
		} else if (this.props.user.plan.status !== undefined && this.props.user.plan.status.canceled === true) {
			content = (
				<div>
					<UpgradePricing
						{...this.props}
						onAddOnUpdate={this.updateSubscriptionAddOns}
						subscriptionUpdate={this.changePlan}
						errors={this.state.errors}
						setRequestParams={this.setRequestParams}
						promoClick={this.promoClick}
						cancelPlan={this.cancelPlan}
						restartPlan={this.restartPlan} />
				</div>
			);
		} else if (!_.isEmpty(this.props.plans.current) && this.props.router.location.pathname.match(/change/) && this.state.errors === null) {
			let termShortLabel = 'month',
				newLevel = this.props.plans.current.planLevel,
				addOns = {},
				newPrice = {},
				priceLabel = '',
				priceInfo = (parseInt(this.state.subscription.term, 10) === constants.SUBSCRIPTION_TERM_ANNUAL) ? (
					<div className="price-info">
						Billed Annually
					</div>
				) : null;

			// get the requested plan level or assume one
			if (this.props.router.query !== null && this.props.router.query.plan !== undefined) {
				newLevel = parseInt(this.props.router.query.plan, 10);
			} else {
				switch (this.props.plans.current.planLevel) {
					case constants.PUB_LEVEL_2:
					case constants.PUB_LEVEL_3:
					case constants.PUB_LEVEL_4:
					case constants.PUB_LEVEL_6:
					case constants.PUB_LEVEL_7:
						newLevel = constants.PUB_LEVEL_9;
						break;

					case constants.PUB_LEVEL_8:
						newLevel = constants.PUB_LEVEL_10;
						break;

					case constants.PUB_LEVEL_9:
						newLevel = constants.PUB_LEVEL_8;
						break;

					case constants.PUB_LEVEL_15:
						newLevel = constants.PUB_LEVEL_6;
						break;

					case constants.PUB_LEVEL_16:
						newLevel = constants.PUB_LEVEL_6;
						break;
				}
			}

			addOns = this.props.getAdjustedAddOns(newLevel);
			newPrice = this.props.calculateAddOns([{
				addOn: constants.SUBSCRIPTION_ADDON_SOCIALS,
				quantity: addOns
			}], this.props.plans.details[newLevel]);
			priceLabel = (parseInt(this.state.subscription.term, 10) === constants.SUBSCRIPTION_TERM_ANNUAL) ? newPrice.annualMonthlyPrice : newPrice.price;
			priceInfo = (parseInt(this.state.subscription.term, 10) === constants.SUBSCRIPTION_TERM_ANNUAL) ? (
				<div className="price-info">
					Billed Annually
				</div>
			) : null;

			content = (
				<PlanDetailBlock
					{...this.props}
					context="upgrade"
					currentPlan={newLevel}
					currentTerm={this.state.subscription.term}
					startUpgrade={(e) => {
						let nextSubscription = Object.assign({}, this.state.subscription);

						nextSubscription.level = newLevel;

						this.setState({
							subscription: nextSubscription
						}, () => {
							this.updatePlan();
						});

					}}
					updateCurrentPlan={(e) => {
						let nextTerm = null,
							nextAddOns = 0,
							nextSubscription = Object.assign({}, this.state.subscription);

						if (e.currentTarget.dataset.term !== undefined) {
							nextTerm = parseInt(e.currentTarget.dataset.term);
							nextSubscription.term = nextTerm;
						}

						if (e.currentTarget.dataset.addOns !== undefined) {
							nextAddOns = parseInt(e.currentTarget.dataset.addOns);
							nextSubscription.addOns = nextAddOns;
						}

						if (!_.isEqual(nextSubscription, this.state.subscription)) {
							this.setState({
								subscription: nextSubscription
							});
						}

					}}
					processing={false}
					currentAddOns={this.state.subscription.addOns} />
			);

			return (
				<div className="upgrade-subscription">
					<main className="subscription-content-block">
						{content}
					</main>
				</div>
			);
		} else if (legacyPlans.indexOf(parseInt(this.props.user.detail.pubLevel)) !== -1) {
			content = (
				<div>
					<LegacyPricing
						{...this.props}
						onAddOnUpdate={this.updateSubscriptionAddOns}
						currentSubscription={this.state.subscription}
						planDetails={this.props.plans.details}
						subscriptionUpdate={this.changePlan}
						errors={this.state.errors}
						promoClick={this.promoClick}
						cancelPlan={this.cancelPlan}
						setRequestParams={this.setRequestParams}
						restartPlan={this.restartPlan} />

				</div>
			);
		} else {
			content = (
				<div>
					<UpgradePricing
						{...this.props}
						onAddOnUpdate={this.updateSubscriptionAddOns}
						subscriptionUpdate={this.changePlan}
						errors={this.state.errors}
						setRequestParams={this.setRequestParams}
						promoClick={this.promoClick}
						cancelPlan={this.cancelPlan}
						restartPlan={this.restartPlan}  />

				</div>
			);
		}

		return (
			<div className="app-column content main" >
				<main className="content-container">
					{content}
				</main>
			</div>
		);
	}
};

Subscription.displayName = "Subscription";

const enhance = compose(
	ComponentWithContext,
	PricingModule
);

export default enhance(Subscription);
